import { render, staticRenderFns } from "./kw_audio.vue?vue&type=template&id=1b17bf32&scoped=true&"
import script from "./kw_audio.vue?vue&type=script&lang=js&"
export * from "./kw_audio.vue?vue&type=script&lang=js&"
import style0 from "./kw_audio.vue?vue&type=style&index=0&id=1b17bf32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b17bf32",
  null
  
)

component.options.__file = "kw_audio.vue"
export default component.exports